import { createUserManager } from 'redux-oidc';
import mockUserManager from './mockUserManager';

const config = {
  client_id: 'provision-app',
  authority: process.env.REACT_APP_AUTH_URL, // replace with real auth link based on environment  client_id: 'js',
  redirect_uri: `${window.location.origin}/callback`, // created callback file to finalize open ID loop
  response_type: 'id_token token',
  scope: 'openid profile internal_credential',
  extraQueryParams: {
    ui_locales: 'en',
    primaryColor: '1c1c1c',
    faviconUrl:
      'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-favicon.ico',
    logoLink:
      'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-logo.png',
  },
};

let userManager;
if (process.env.REACT_APP_MOCK_LOGIN) {
  console.log('Mocking user login');
  userManager = mockUserManager(userManager);
} else {
  userManager = createUserManager(config);
}

export default userManager;
